import { ChangeDetectionStrategy, Component, HostListener, inject } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { QuickNavigationService } from '@pages/layout/components/quick-navigation/quick-navigation.service';

import { AnalyticsService } from '@core/analytics/analytics.service';
import { TagEvent } from '@core/analytics/enums/tag-event.enum';

import { ConnectionLostOverlayComponent } from '@shared/components/connection-lost-overlay';
import { JsonEditorComponent } from '@shared/components/json-editor';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, JsonEditorComponent, ConnectionLostOverlayComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  readonly #router = inject(Router);
  readonly #analyticsService = inject(AnalyticsService);
  readonly #quickNavigationService = inject(QuickNavigationService);

  constructor() {
    this.#pushPageTags();
  }

  #pushPageTags(): void {
    this.#router.events.forEach((item) => {
      if (item instanceof NavigationEnd) {
        this.#analyticsService.pushEvent({
          event: TagEvent.Page,
          page_url: item.url,
        });
      }
    });
  }

  @HostListener('document:keydown', ['$event'])
  public onDocumentKeydown(event: KeyboardEvent): void {
    if (
      event.defaultPrevented ||
      event.altKey ||
      event.shiftKey ||
      (!event.metaKey && !event.ctrlKey) ||
      event.key.toLocaleLowerCase() !== 'k'
    ) {
      return;
    }

    event.preventDefault();
    this.#quickNavigationService.open();
  }
}
